import { tns } from "tiny-slider/src/tiny-slider";

for (let i = 0; i < $(".slider").length; i++) {
  sliderInit(i);
}

function sliderInit(i) {
  const id = $(".slider").eq(i).find(".slider__wrapper").data("id");

  let slider = tns({
    container: ".slider .slider__wrapper[data-id='" + id + "']",
    gutter: 20,
    nav: false,
    loop: false,
    speed: 800,
    controlsContainer: ".slider__control[data-id='" + id + "']",
    items: 1,
    responsive: {
      768: {
        items: 2,
        gutter: 20,
      },
      1540: {
        items: 3
      },
    },
  });
  $(".slider .slider__wrapper[data-id='" + id + "']").attr('data-slide-count', slider.getInfo().slideCount);
  slider.events.on('indexChanged', (info) => {
    const event = jQuery.Event('slider-index-changed')
    event.tinySliderInfo = info
    $(".slider .slider__wrapper[data-id='" + id + "']").trigger(event)
  })
}

questionsSliderInit();

function questionsSliderInit() {
  for (let i = 0; i < $(".quiz__slider").length; i++) {
    const id =  $(".quiz__slider").eq(i).find(".slider__wrapper").data("id");
    const slider = tns({
      container: ".quiz__slider .slider__wrapper[data-id='" + id + "']",
      items: 1,
      gutter: 0,
      speed: 800,
      nav: false,
      loop: false,
      autoHeight: true,
      controls: false
    });
    $(".quiz__slider .slider__wrapper[data-id='" + id + "']").attr('data-slide-count', slider.getInfo().slideCount);
    slider.events.on('indexChanged', (info) => {
      const event = jQuery.Event('slider-index-changed')
      event.tinySliderInfo = info
      $(".quiz__slider .slider__wrapper[data-id='" + id + "']").trigger(event)
    })
    const questions = $('#progress-'+id).data('length');
    setBarWidth(id, calculateBarWidth(slider, questions));
    $('.quiz-next').on('click', function () {
      slider.goTo('next');
      setBarWidth(id, calculateBarWidth(slider, questions));
      setTimeout(function () {
          slider.updateSliderHeight();
      }, 500);
    });

    $(".question-answer").on("click", function () {
      const num = $(this).attr("data-num");
      const key = $(this).attr("data-key");
      const parent =  $(this).closest(".slider__wrapper").attr('data-id');
      $('.quiz-comment').fadeOut('fast');
      setTimeout(function () {
          $('#'+parent + ' #quiz-comment-'+num).fadeIn('fast');
          $('#'+parent + ' #quiz-next-'+key).fadeIn('fast');
          slider.updateSliderHeight();
      }, 500);
    });

    $('.accordion__heading').on("click", function() {
      setTimeout(function () {
        slider.updateSliderHeight();
      }, 0);
    });
  };


}

function setBarWidth(id, barWidth) {
  $('#progress-'+id).css('width', barWidth + "%");
}

function calculateBarWidth(slider, questions) {
  return (slider.getInfo().displayIndex/questions) * 100;
}

$('.slideshow').each(function(i) {
  contentSlideshow(i);
});

function contentSlideshow(i) {
  const id = $(".slideshow").eq(i).data("id");
  const slider = tns({
    container: ".slideshow[data-id='" + id + "'] .slideshow-wrapper",
    speed: 800,
    navPosition: "bottom",
    controlsContainer: ".slideshow[data-id='" + id + "'] .slideshow__control",
  });
  $(".slideshow[data-id='" + id + "'] .slideshow-wrapper").attr('data-slide-count', slider.getInfo().slideCount);
  slider.events.on('indexChanged', (info) => {
    const event = jQuery.Event('slider-index-changed')
    event.tinySliderInfo = info
    $(".slideshow[data-id='" + id + "'] .slideshow-wrapper").trigger(event)
  })
}